import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputDailyTimeTargets<T extends EMode = EMode.entity> {
  /** Alias: monday */
  monday?: any;
  /** Alias: tuesday */
  tuesday?: any;
  /** Alias: wednesday */
  wednesday?: any;
  /** Alias: thursday */
  thursday?: any;
  /** Alias: friday */
  friday?: any;
  /** Alias: saturday */
  saturday?: any;
  /** Alias: sunday */
  sunday?: any;

  __typename?: string;
}

const fields: FieldDefinitions<InputDailyTimeTargets> = {
  monday: {
    alias: 'monday',
  },
  tuesday: {
    alias: 'tuesday',
  },
  wednesday: {
    alias: 'wednesday',
  },
  thursday: {
    alias: 'thursday',
  },
  friday: {
    alias: 'friday',
  },
  saturday: {
    alias: 'saturday',
  },
  sunday: {
    alias: 'sunday',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputDailyTimeTargetsEntityDefinition: EntitiyDefinition<InputDailyTimeTargets> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputDailyTimeTargets',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
